/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const claimTransactionsDirective = require('./claimTransactionsDirective');

const claimTransactionsModule = angular
    .module('enervee_utils.claimTransactions', [])
    .directive('claimTransactions', claimTransactionsDirective);

module.exports = claimTransactionsModule;